import { graphql } from '../__generated__/gql';

export const GET_ALL_SCAFFOLDS = graphql(/* GraphQL */ `
  query Scaffolds($assetId: Int!) {
    allScaffolds(assetId: $assetId) {
      scaffoldId
      assetId
      planRef
      description
      weight
      safeWorkingLimit
      width
      height
      length
      teamSize
      erectHours
      dismantleHours
      outsideCover
      status
      comments
      updatedAt
      updatedBy
      tarJobs {
        jobId
      }
    }
  }
`);

export const GET_JOB_SCAFFOLDS = graphql(/* GraphQL */ `
  query JobScaffolds($jobId: Int!) {
    scaffoldsByJobId(jobId: $jobId) {
      scaffoldId
      assetId
      planRef
      description
      weight
      safeWorkingLimit
      width
      height
      length
      teamSize
      erectHours
      dismantleHours
      outsideCover
      status
      comments
      updatedAt
      tarJobs {
        jobId
      }
    }
  }
`);

export const CREATE_SCAFFOLD = graphql(/* GraphQL */ `
  mutation CreateScaffold($input: ScaffoldInput!) {
    createScaffold(input: $input) {
      scaffoldId
    }
  }
`);

export const UPDATE_SCAFFOLD = graphql(/* GraphQL */ `
  mutation UpdateScaffold($input: ScaffoldInput!) {
    updateScaffold(input: $input) {
      scaffoldId
    }
  }
`);

export const LINK_SCAFFOLD_JOBS = graphql(/* GraphQL */ `
  mutation LinkScaffoldJobs($scaffoldId: Int!, $jobIds: [Int]!) {
    linkScaffoldJobs(scaffoldId: $scaffoldId, jobIds: $jobIds) {
      scaffoldId
    }
  }
`);

export const REMOVE_SCAFFOLD = graphql(/* GraphQL */ `
  mutation RemoveScaffold($scaffoldId: Int!) {
    removeScaffold(scaffoldId: $scaffoldId)
  }
`);
